import { observable, action, get, computed, autorun } from 'mobx'
import Parse from 'parse'
import _ from 'lodash'
import directus from '../utils/directus'


class MediaStore {

  @observable media
  @observable loaded
  @observable loadCounter

  constructor() {
    this.media = []
    this.loaded = false
    this.loadCounter = 0
  }

  @action setMedia = (media) => {
    this.media = media
  }
  @action setLoaded = () => {
    this.loaded = true
  }

  async loadMedia () {
    try {
      const data = await directus.get('items/global_images?fields=*.*&limit=-1')
      this.setMedia(data.data.data)
      this.setLoaded()

    } catch (err) {
      console.log(err)

      if(this.loadCounter > 5) {
        // window.location.reload()
        return
      }

      setTimeout(() => {
        this.loadCounter++
        this.loadMedia()
      }, 200);
    }
  }
  
  globalImage(key, transform) {
    const target = this.media && this.media.find((item) => item.key === key)
    const id = target && target.image.id

    if (!transform) {
      return process.env.REACT_APP_DIRECTUS_BACKEND + 'assets/' + id
    }
    return process.env.REACT_APP_DIRECTUS_BACKEND + 'assets/' + id + '?key=' + transform
  }
}

const store = new MediaStore()
export default store

autorun(() => {
  if(!store.loaded)
    store.loadMedia()
})



// WEBPACK FOOTER //
// /src/stores/MediaStore.js